import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { HttpHelperService } from '../http-helper/http-helper.service';
import { PageHelperService } from '../page-helper/page-helper.service';
import { AppLauncher } from '@capacitor/app-launcher';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  private platform = inject(Platform);
  private httpHelper = inject(HttpHelperService);
  private pageHelper = inject(PageHelperService);

  constructor() {}

  shouldForceUpdateApp(): boolean {
    const forceUpdateOn = this.httpHelper.getForceUpdateOn();
    const forceUpdateRequire = this.httpHelper.getForceUpdateRequire();
    //If force update feature flag is ON and BFF determines that force update is required then show Alert to user.
    return forceUpdateOn && forceUpdateRequire;
  }

  checkForForceUpdate() {
    let message;
    if (this.platform.is('ios')) {
      message =
        'There is a newer version available for download! Please update the app by visiting the App Store.';
    } else {
      message =
        'There is a newer version available for download! Please update the app by visiting the Play Store.';
    }
    if (this.shouldForceUpdateApp()) {
      // Close any existing alerts
      this.pageHelper.closeAlert();
      this.pageHelper.showAlert({
        header: 'New Version Available',
        message: message,
        buttons: [
          {
            text: 'Update',
            handler: () => {
              this.appStoreNavigation();
              return false; // So the alert doesn't dismiss when clicked on.
            },
          },
        ],
        backdropDismiss: false,
      });
    }
  }

  //take user to Apple or Android app store pages to udpate the app.
  private appStoreNavigation() {
    if (this.platform.is('ios')) {
      AppLauncher.openUrl({
        url: this.httpHelper.getStaticAppleAppStoreUrl(),
      });
    } else if (this.platform.is('android')) {
      AppLauncher.openUrl({
        url: this.httpHelper.getStaticAndroidPlayStoreUrl(),
      });
    }
  }
}
